export default function initOpenClose() {
  const dropDowns = document.querySelectorAll('[data-dropdown]');
  if (!dropDowns.length) return;
  const dropDownItem = '[data-dropdown-item]';
  const dropDownContent = '[data-dropdown-content]';
  const isDropDownClass = 'is-dropdown-item';
  const isDropDownActiveClass = 'is-dropdown-active';
  const screeSize = window.matchMedia('(min-width: 768px)');
  dropDowns.forEach((item) => {
    const dropDownOpeners = item.querySelectorAll('[data-dropdown-opener]');
    dropDownOpeners.forEach((btn) => {
      const parent = btn.closest(dropDownItem);
      parent.classList.add(isDropDownClass);
      const drop = parent?.querySelector(dropDownContent);
      drop.setAttribute('style', 'height: 0px;');

      const handelMobileOpenClose = (e) => {
        e.preventDefault();
        console.log('mobile open close');
        parent?.classList.toggle(isDropDownActiveClass);
        if (parent.classList.contains(isDropDownActiveClass)) {
          drop.style.height = `${drop.scrollHeight}px`;
        } else if (!parent.classList.contains(isDropDownActiveClass)) {
          drop.style.height = `${0}px`;
        }
      };

      const handelLargeOpenClose = (e) => {
        e.preventDefault();
        console.log('large open close');
        if (!parent.classList.contains(isDropDownActiveClass)) {
          parent.classList.add(isDropDownActiveClass);
        } else if (parent.classList.contains(isDropDownActiveClass)) {
          parent.classList.remove(isDropDownActiveClass);
        }
      };

      const handelResize = () => {
        if (!screeSize.matches) {
          btn.addEventListener('click', handelMobileOpenClose);
          btn.removeEventListener('click', handelLargeOpenClose);
        } else {
          drop.removeAttribute('style', 'height: 0px;');
          btn.addEventListener('click', handelLargeOpenClose);
          btn.removeEventListener('click', handelMobileOpenClose);
          document.addEventListener('click', handelOutSlideClick);
        }
      };

      const handelOutSlideClick = (e) => {
        if (!parent.contains(e.target)) {
          parent.classList.remove(isDropDownActiveClass);
        }
      };

      handelResize();
      screeSize.addEventListener('change', handelResize);
    });
  });
}
